/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DevisPhotoGarantie } from './DevisPhotoGarantie';
import {
    DevisPhotoGarantieFromJSON,
    DevisPhotoGarantieFromJSONTyped,
    DevisPhotoGarantieToJSON,
    DevisPhotoGarantieToJSONTyped,
} from './DevisPhotoGarantie';
import type { DevisPhotoVariable } from './DevisPhotoVariable';
import {
    DevisPhotoVariableFromJSON,
    DevisPhotoVariableFromJSONTyped,
    DevisPhotoVariableToJSON,
    DevisPhotoVariableToJSONTyped,
} from './DevisPhotoVariable';
import type { DevisPhotoFrais } from './DevisPhotoFrais';
import {
    DevisPhotoFraisFromJSON,
    DevisPhotoFraisFromJSONTyped,
    DevisPhotoFraisToJSON,
    DevisPhotoFraisToJSONTyped,
} from './DevisPhotoFrais';

/**
 * Snapshot of a quote (guarantees, ceilings, deductibles, variables, fees, prices) stored with a validation request, for the before/after view.
 * @export
 * @interface DevisPhoto
 */
export interface DevisPhoto {
    /**
     * 
     * @type {Array<DevisPhotoGarantie>}
     * @memberof DevisPhoto
     */
    garanties: Array<DevisPhotoGarantie>;
    /**
     * 
     * @type {Array<DevisPhotoVariable>}
     * @memberof DevisPhoto
     */
    variables: Array<DevisPhotoVariable>;
    /**
     * 
     * @type {Array<DevisPhotoFrais>}
     * @memberof DevisPhoto
     */
    frais: Array<DevisPhotoFrais>;
    /**
     * 
     * @type {number}
     * @memberof DevisPhoto
     */
    prixHt: number;
    /**
     * 
     * @type {number}
     * @memberof DevisPhoto
     */
    prixTtc: number;
    /**
     * 
     * @type {number}
     * @memberof DevisPhoto
     */
    prixClient: number;
    /**
     * 
     * @type {Date}
     * @memberof DevisPhoto
     */
    priseLe: Date;
}

/**
 * Check if a given object implements the DevisPhoto interface.
 */
export function instanceOfDevisPhoto(value: object): value is DevisPhoto {
    if (!('garanties' in value) || value['garanties'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    if (!('frais' in value) || value['frais'] === undefined) return false;
    if (!('prixHt' in value) || value['prixHt'] === undefined) return false;
    if (!('prixTtc' in value) || value['prixTtc'] === undefined) return false;
    if (!('prixClient' in value) || value['prixClient'] === undefined) return false;
    if (!('priseLe' in value) || value['priseLe'] === undefined) return false;
    return true;
}

export function DevisPhotoFromJSON(json: any): DevisPhoto {
    return DevisPhotoFromJSONTyped(json, false);
}

export function DevisPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'garanties': ((json['garanties'] as Array<any>).map(DevisPhotoGarantieFromJSON)),
        'variables': ((json['variables'] as Array<any>).map(DevisPhotoVariableFromJSON)),
        'frais': ((json['frais'] as Array<any>).map(DevisPhotoFraisFromJSON)),
        'prixHt': json['prixHt'],
        'prixTtc': json['prixTtc'],
        'prixClient': json['prixClient'],
        'priseLe': (new Date(json['priseLe'])),
    };
}

export function DevisPhotoToJSON(json: any): DevisPhoto {
    return DevisPhotoToJSONTyped(json, false);
}

export function DevisPhotoToJSONTyped(value?: DevisPhoto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garanties': ((value['garanties'] as Array<any>).map(DevisPhotoGarantieToJSON)),
        'variables': ((value['variables'] as Array<any>).map(DevisPhotoVariableToJSON)),
        'frais': ((value['frais'] as Array<any>).map(DevisPhotoFraisToJSON)),
        'prixHt': value['prixHt'],
        'prixTtc': value['prixTtc'],
        'prixClient': value['prixClient'],
        'priseLe': ((value['priseLe']).toISOString()),
    };
}

